import Vue from 'vue';

Vue.mixin({
  computed: {
    $featureFlags() {
      return this.$store.getters['app/featureFlags'];
    },
  },
  methods: {
    featureEnabled(flagKey) {
      const state = this.$featureFlags[flagKey];
      // If flag doesn't exist, default to enabled
      return state === undefined || state === 'enabled';
    },
    featureVisible(flagKey) {
      const state = this.$featureFlags[flagKey];
      // Visible if enabled, disabled, or flag doesn't exist. Hidden only if 'hidden'.
      return state !== 'hidden';
    },
  },
});
